import React, { useState } from 'react';
import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg';
import erlClient from 'services/clients';
import fonts from 'styles/typography.module.css';

import Button from 'components/customDesign/Button';
import { Avatar, Dialog } from '@mui/material';
import { Profile } from 'types/User';

interface Props {
  selectedMember: Profile;
  submitCallback?: () => void;
}

const ValidateUserDelete: React.FC<Props> = ({ selectedMember, submitCallback }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useState(null);
  const close = () => setIsOpen(false);
  const open = () => setIsOpen(true);
  const removeUser = async () => {
    setError(null);
    try {
      await erlClient.delete('/core/api/v1/auth/company/member/delete', {
        data: {
          email: selectedMember.email,
        },
      });
      close();
      submitCallback?.();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      // eslint-disable-next-line no-console
      console.error(e.response);
      setError(e.response.data.message);
    }
  };
  return (
    <>
      <h5 className="text-red-600 underline text-right cursor-pointer" onClick={open}>
        End membership
      </h5>
      <Dialog
        open={isOpen}
        onClose={close}
        className={`${fonts.font} pt-16`}
        classes={{ paper: 'p-8 flex flex-col items-center gap-2 max-w-[300px]' }}
      >
        <Avatar className="flex-0 bg-darkblue-800">
          <TrashIcon />
        </Avatar>
        <h1 className="text-center font-bold">Are you sure?</h1>
        <h5 className="text-gray-500 text-center">The member will be removed from your team.</h5>
        {error && <h4 className="text-red-600">{error}</h4>}
        <Button
          className="w-[200px]"
          onClick={removeUser}
          rightIcon={
            <Avatar className="h-5 w-5 bg-darkblue-800 ml-2">
              <TrashIcon height="12px" />
            </Avatar>
          }
        >
          End membership
        </Button>
      </Dialog>
    </>
  );
};
ValidateUserDelete.displayName = 'Settings.Profile.ValidateUserDelete';

export default ValidateUserDelete;
